import { render } from "./ErrorRecap.vue?vue&type=template&id=45e70cf0&scoped=true&ts=true"
import script from "./ErrorRecap.vue?vue&type=script&lang=ts"
export * from "./ErrorRecap.vue?vue&type=script&lang=ts"

import "./ErrorRecap.vue?vue&type=style&index=0&id=45e70cf0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src317777935/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e70cf0"]])

export default __exports__